import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import { Button, Card, ChevronRight, Icon } from '@whitbread-eos/atoms';
import { SRHotelDistance, SRHotelThumbnail, SRHotelTitle } from '@whitbread-eos/molecules';
import { formatAssetsUrl, formatDataTestId, useCustomLocale } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MapHotelCard(_ref) {
  var _links$detailsPage, _topSectionImages$0$t, _topSectionImages$, _topSectionImages$0$i, _topSectionImages$2, _firstFacilityDisplay;
  var data = _ref.data,
    hideHotelDistance = _ref.hideHotelDistance;
  var links = data.links,
    brand = data.brand,
    name = data.name,
    topSectionImages = data.topSectionImages,
    hotelFacilities = data.hotelFacilities,
    tripAdvisorReviews = data.tripAdvisorReviews,
    distanceFromReference = data.distanceFromReference;
  var hotelSlug = (_links$detailsPage = links === null || links === void 0 ? void 0 : links.detailsPage) !== null && _links$detailsPage !== void 0 ? _links$detailsPage : '';
  var hotelBrand = brand !== null && brand !== void 0 ? brand : '';
  var hotelName = name !== null && name !== void 0 ? name : '';
  var imageAltText = "".concat(hotelName, " ").concat((_topSectionImages$0$t = topSectionImages === null || topSectionImages === void 0 || (_topSectionImages$ = topSectionImages[0]) === null || _topSectionImages$ === void 0 || (_topSectionImages$ = _topSectionImages$.tags) === null || _topSectionImages$ === void 0 ? void 0 : _topSectionImages$[0]) !== null && _topSectionImages$0$t !== void 0 ? _topSectionImages$0$t : 'exterior');
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var imageURLHotelExterior = "".concat((_topSectionImages$0$i = topSectionImages === null || topSectionImages === void 0 || (_topSectionImages$2 = topSectionImages[0]) === null || _topSectionImages$2 === void 0 ? void 0 : _topSectionImages$2.imageSrc) !== null && _topSectionImages$0$i !== void 0 ? _topSectionImages$0$i : t('dlp.hotelCard.img.placeholder'));
  var hotelBrandLogos = {
    hubLogo: t('dlp.hotelCard.hubBadge'),
    zipLogo: t('dlp.hotelCard.zipBadge')
  };
  var hotelDistanceLabels = {
    distanceUnitPlural: t('dlp.hotelCard.distance.unitPlural'),
    fromLocation: t('dlp.hotelCard.distance.fromLocation')
  };
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var baseDataTestId = 'DLP';
  var URLToRedirect = "/".concat(country, "/").concat(language, "/hotels").concat(hotelSlug, ".html");
  var firstFacilityDisplayed = hotelFacilities === null || hotelFacilities === void 0 ? void 0 : hotelFacilities[0];
  return _jsx(Box, _objectSpread(_objectSpread({}, wrapperStyles), {}, {
    children: _jsx(Link, _objectSpread(_objectSpread({
      href: URLToRedirect
    }, linkStyles), {}, {
      children: _jsx(Card, _objectSpread(_objectSpread({}, cardContainerStyles), {}, {
        "data-testid": formatDataTestId(baseDataTestId, 'hotel-card'),
        children: _jsxs(Flex, {
          direction: "row",
          w: "full",
          children: [_jsxs(Flex, {
            direction: "column",
            children: [_jsx(SRHotelThumbnail, {
              imageData: {
                imageSrc: imageURLHotelExterior,
                imageAlt: imageAltText
              },
              brand: hotelBrand,
              brandLogos: hotelBrandLogos,
              testId: formatDataTestId(baseDataTestId, 'hotel-thumbnail'),
              styles: hotelThumbnailWrapperStyles
            }), (tripAdvisorReviews === null || tripAdvisorReviews === void 0 ? void 0 : tripAdvisorReviews.reviews) && (tripAdvisorReviews === null || tripAdvisorReviews === void 0 ? void 0 : tripAdvisorReviews.rating) && _jsx(Flex, _objectSpread(_objectSpread({}, taContainerStyles), {}, {
              children: _jsx(Link, {
                href: "".concat(URLToRedirect, "#tripadvisor-reivew-section-bottom"),
                target: "_blank",
                children: _jsx(Image, _objectSpread(_objectSpread({}, taImageStyles), {}, {
                  src: "https://static.tacdn.com/img2/ratings/traveler/".concat((Math.round(tripAdvisorReviews.rating * 2) / 2).toFixed(1), ".svg"),
                  alt: "ta-ratings-img"
                }))
              })
            }))]
          }), _jsxs(Flex, _objectSpread(_objectSpread({}, hotelDetailsBoxStyles), {}, {
            children: [_jsx(SRHotelTitle, {
              title: hotelName,
              testId: formatDataTestId(baseDataTestId, 'hotel-title'),
              styles: titleStyles
            }), distanceFromReference && !hideHotelDistance && _jsx(SRHotelDistance, {
              distance: parseFloat(distanceFromReference.toFixed(2)),
              unit: "miles",
              labels: hotelDistanceLabels,
              testId: formatDataTestId(baseDataTestId, 'hotel-distance'),
              styles: hotelDistanceTextStyles
            }), firstFacilityDisplayed && _jsxs(Flex, {
              direction: "row",
              gap: "1",
              children: [_jsx(Box, {
                as: "span",
                width: "16px",
                "data-testid": formatDataTestId(baseDataTestId, 'hotel-facility'),
                children: _jsx(Icon, {
                  "data-testid": formatDataTestId(baseDataTestId, 'hotel-facility-icon'),
                  src: formatAssetsUrl((_firstFacilityDisplay = firstFacilityDisplayed === null || firstFacilityDisplayed === void 0 ? void 0 : firstFacilityDisplayed.icon) !== null && _firstFacilityDisplay !== void 0 ? _firstFacilityDisplay : '')
                })
              }), _jsx(Text, _objectSpread(_objectSpread({}, hotelFacilityTextStyles), {}, {
                children: firstFacilityDisplayed === null || firstFacilityDisplayed === void 0 ? void 0 : firstFacilityDisplayed.name
              }))]
            }), _jsx(Flex, _objectSpread(_objectSpread({}, hotelButtonBoxStyles), {}, {
              "data-testid": formatDataTestId(baseDataTestId, 'hotel-button'),
              children: _jsx(Button, _objectSpread(_objectSpread({
                size: "xxs",
                variant: "circle"
              }, buttonStyles), {}, {
                children: _jsx(Icon, {
                  svg: _jsx(ChevronRight, {
                    color: "var(--chakra-colors-baseWhite)"
                  })
                })
              }))
            }))]
          }))]
        })
      }))
    }))
  }));
}
var wrapperStyles = {
  w: {
    mobile: '17.9rem',
    sm: '18.75rem'
  },
  h: '10.625rem'
};
var linkStyles = {
  display: 'flex',
  h: '100%',
  cursor: 'default',
  _hover: {
    textDecoration: 'none'
  },
  _focus: {
    textDecoration: 'none',
    boxShadow: 'none'
  },
  _visited: {
    textDecoration: 'none'
  },
  _link: {
    textDecoration: 'none'
  },
  _active: {
    textDecoration: 'none'
  }
};
var cardContainerStyles = {
  bgColor: 'baseWhite',
  w: 'full',
  border: '1px solid var(--chakra-colors-primary)',
  borderRadius: 'var(--chakra-space-radiusSmall)',
  boxShadow: 'none',
  padding: '0',
  _hover: {
    cursor: 'pointer',
    boxShadow: '0 0 var(--chakra-space-sm) 0 var(--chakra-colors-lightGrey2)',
    transitionProperty: 'border, box-shadow',
    transitionDuration: '0s, 0s',
    transitionTimingFunction: 'ease, ease',
    transitionDelay: '0s, 0s'
  }
};
var titleStyles = {
  fontSize: 'sm',
  fontWeight: 'bold',
  color: 'darkGrey1'
};
var hotelThumbnailWrapperStyles = {
  h: '120px',
  w: '125px'
};
var hotelDetailsBoxStyles = {
  p: 'xmd',
  flexDirection: 'column',
  h: '11.438rem'
};
var hotelDistanceTextStyles = {
  fontSize: 'var(--chakra-space-xmd)',
  fontWeight: 'normal',
  paddingTop: 'xs',
  paddingBottom: 'sm',
  flex: 0
};
var hotelFacilityTextStyles = {
  alignSelf: 'center',
  fontSize: 'var(--chakra-space-xmd)',
  fontWeight: 'normal'
};
var hotelButtonBoxStyles = {
  pl: {
    mobile: 'sm',
    md: '0'
  },
  pr: {
    mobile: '0'
  },
  alignSelf: 'end',
  m: 'auto 0 var(--chakra-space-xmd) auto'
};
var buttonStyles = {
  bgColor: 'primary',
  _hover: {
    bg: 'var(--chakra-colors-btnPrimaryHoverBg) radial-gradient(circle, transparent 1%, var(--chakra-colors-btnPrimaryHoverBg) 1%) center/15000%',
    boxShadow: '0 4px 8px var(--chakra-colors-lightGrey1)',
    _disabled: {
      bg: 'lightGrey3'
    }
  }
};
var taImageStyles = {
  h: '20px'
};
var taContainerStyles = {
  py: 'md'
};